import React, { FC } from 'react'
import { t, Trans } from '@lingui/macro'

import { linkBuilder } from '../../../../../shared/linkBuilder'
import TriangleRight from './TriangleRight'
import {
  ResourceCard,
  resourceCardCoverImageSrcSet
} from '../../workspace-page/resource-card/ResourceCard'
import ArrowRight from 'public/assets/img/arrow-right.svg'
import './UpNext.less'
import { Link } from 'front-end/src/components'
import { TopicDetailContextType } from '../TopicDetailContext'
import { PathwayNextTopicFragment } from '../TopicDetailPage.codegen'

interface IProps {
  pathway: {
    id: number
    title: string
  }
  topic: TopicDetailContextType['nextInPathway']
}

const getImage = (
  coverImage: PathwayNextTopicFragment['coverImage'],
  coverImageVariants: PathwayNextTopicFragment['coverImageVariants']
) => {
  if (!coverImage) {
    return null
  }
  const resizedImage = coverImageVariants.find(
    (imageVariant) => imageVariant.size_key === '300x200'
  )
  return resizedImage ? resizedImage.cdnUrl : coverImage.cdnUrl
}

const UpNext: FC<IProps> = ({ topic, pathway }) => {
  if (!topic?.currentTopicVersion) {
    return null
  }
  return (
    <section className="UpNext">
      <div className="UpNext__Arrow">
        <div className="UpNext__Arrow_Container">
          <div>
            <h4>
              <Trans>Up next</Trans>
            </h4>
            <p>
              <Trans>Continue to the next resource in</Trans>{' '}
              <Link href={`${linkBuilder.pathwayDetail(pathway.id)}`}>
                {pathway.title}
              </Link>
            </p>
            <img
              className={'IconArrowRight'}
              src={ArrowRight}
              alt={t`Arrow right`}
            />
          </div>
          <div>
            <TriangleRight backgroundColor="#e3e8ea" />
          </div>
        </div>
      </div>
      <div className="UpNext_Card">
        <ResourceCard
          author={topic.author}
          title={topic.currentTopicVersion.title}
          description={topic.currentTopicVersion.summary}
          image={getImage(topic.coverImage, topic.coverImageVariants)}
          imageSrcSet={resourceCardCoverImageSrcSet(topic.coverImageVariants)}
          readDurationMins={topic.currentTopicVersion.readDurationMins}
          topicId={topic.id}
          pathway={pathway}
        />
      </div>
    </section>
  )
}

export default UpNext
